import {
  GET,
  POST,
  GET_CLAIMS_WAIT_APPROVE,
  POST_CLAIM_APPROVE_NO_DEDUCT,
  POST_CLAIM_REJECT_NO_DEDUCT,
} from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { openAlert } from '../../../../components/alert/useAlert';
import { rowsFromApproveResponse, showCsSendResult } from '../../../../components/cs-send-result';

export const useClaimApprove = () => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearch } = useMutation({
    mutationFn: async (searchParamState = {}) => {
      const search = String(searchParamState.search || '').trim();
      const response = await GET(GET_CLAIMS_WAIT_APPROVE(search ? { search } : {}));

      return response.result.items || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });

  const onFetch = (params) => onSearch(params);

  return { dataSource: data, onFetch, loading: isPending };
};

export const useApproveNoDeduct = ({ modal, onSuccessCallBack }) =>
  useMutation({
    mutationFn: async ({ claimIdList, remark }) => {
      const response = await POST(POST_CLAIM_APPROVE_NO_DEDUCT(), {
        claimIdList,
        remark,
      });
      if (response?.success === false) throw new Error(response.message);

      return response;
    },
    onSuccess: (response) => {
      if (onSuccessCallBack) onSuccessCallBack(response);
      showCsSendResult(modal, {
        title: 'อนุมัติไม่ตัดประกันสำเร็จ ผลการส่ง CS',
        rows: rowsFromApproveResponse(response),
      });
    },
  });

export const useRejectNoDeduct = ({ onSuccessCallBack }) =>
  useMutation({
    mutationFn: async ({ claimId, remark }) => {
      const response = await POST(POST_CLAIM_REJECT_NO_DEDUCT(), {
        claimId,
        remark,
      });
      if (response?.success === false) throw new Error(response.message);

      if (onSuccessCallBack) onSuccessCallBack(response, claimId);

      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'คืนเป็นเคลมตัดประกันปกติแล้ว กรุณาอนุมัติในหน้าเคลมสินค้า',
      });
    },
  });
